import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { withTheme } from '@material-ui/core';

class SvgSDM17SPGInstall extends PureComponent {
    static propTypes = {
        size: PropTypes.number,
        color: PropTypes.string
    };

    static defaultProps = {
        size: 50,
        color: '#8e8e8e'
    };

    render() {
        const { color, size } = this.props;
        return (
            <svg height={(size / 1.5).toString()} width={(size / 1.5).toString()} viewBox="0 0 174.33 300">
                <g fill={color}>
                    <path
                        d="M150,154.15a60.1,60.1,0,1,0,60.1,60.1A60.1,60.1,0,0,0,150,154.15Zm-27,70.6a11,11,0,1,1,11-11A11,11,0,0,1,123,224.75Zm52,0a11,11,0,1,1,11-11A11,11,0,0,1,175,224.75Z"
                        transform="translate(-62.83)"
                    />
                    <path
                        d="M183,15a39.21,39.21,0,0,1,39.17,39.25V245.71A39.21,39.21,0,0,1,183,285H117a39.21,39.21,0,0,1-39.17-39.25V54.29A39.21,39.21,0,0,1,117,15h66m0-15H117A54.29,54.29,0,0,0,62.83,54.29V245.71A54.29,54.29,0,0,0,117,300h66a54.29,54.29,0,0,0,54.17-54.29V54.29A54.29,54.29,0,0,0,183,0Z"
                        transform="translate(-62.83)"
                    />
                    <rect x="82.89" y="24.08" width="8.55" height="13.54" rx="2.69" ry="2.69" />
                    <path
                        d="M154.27,56.36V52.15a2.69,2.69,0,0,0-2.69-2.69h-3.17a2.69,2.69,0,0,0-2.69,2.69v4.21a13.67,13.67,0,1,0,8.55,0Z"
                        transform="translate(-62.83)"
                    />
                </g>
            </svg>
        );
    }
}

export default withTheme(SvgSDM17SPGInstall);



// WEBPACK FOOTER //
// ./data/common/iconsvg/SvgSDM17SPGInstall.js